import React, { useState } from 'react';
import {
  Box,
  Container,
  Title,
  Text,
  Card,
  Stack,
  Center,
  Grid,
  ThemeIcon,
  Button
} from '@mantine/core';
import { IconFileMusic, IconCode } from '@tabler/icons-react';

import AudioFileGenerator from './AudioFileGenerator';
import UccxScriptTranslator from './UccxScriptTranslator';
import PlatformBackButton from '../../components/PlatformBackButton';

const tools = {
  audioGenerator: {
    name: 'Audio File Generator',
    description: 'Generate and manage audio files for contact center use cases',
    color: 'teal',
    icon: IconFileMusic,
    component: AudioFileGenerator,
    comingSoon: false
  },
  uccxTranslator: {
    name: 'UCCX Script Translator',
    description: 'Upload a Cisco UCCX .aef script to get an AI-powered flow diagram and full script analysis',
    color: 'teal',
    icon: IconCode,
    component: UccxScriptTranslator,
    comingSoon: false
  }
};

function CcUtilsHub({ onBackToPlatformSelector, platformInfo }) {
  const [selectedTool, setSelectedTool] = useState(null);

  if (selectedTool) {
    const tool = tools[selectedTool];
    const ToolComponent = tool.component;
    return (
      <ToolComponent
        onBackToHome={() => setSelectedTool(null)}
        onBackToPlatformSelector={onBackToPlatformSelector}
        platformInfo={platformInfo}
      />
    );
  }

  return (
    <Box
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #20c997 0%, #0c8599 100%)',
        padding: '40px 20px'
      }}
    >
      <Container size="lg">
        <PlatformBackButton onClick={onBackToPlatformSelector} onGradient mb="lg" />

        <Center>
          <Stack align="center" gap="xl" style={{ maxWidth: '800px', width: '100%' }}>
            <Stack align="center" gap="md">
              <Title
                order={1}
                size="3rem"
                fw={700}
                style={{ color: 'white', textAlign: 'center' }}
              >
                Contact Center Utilities
              </Title>
              <Text
                size="xl"
                style={{ color: 'rgba(255,255,255,0.9)', textAlign: 'center' }}
              >
                Select a tool to get started
              </Text>
            </Stack>

            <Grid gutter="xl" style={{ width: '100%' }}>
              {Object.entries(tools).map(([key, tool]) => {
                const IconComponent = tool.icon;

                return (
                  <Grid.Col key={key} span={{ base: 12, sm: 6, md: 4 }}>
                    <Card
                      shadow="xl"
                      padding="xl"
                      radius="md"
                      onClick={() => setSelectedTool(key)}
                      style={{
                        background: 'white',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        height: '300px',
                        display: 'flex',
                        flexDirection: 'column',
                        border: '2px solid transparent',
                        position: 'relative'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-8px)';
                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                        e.currentTarget.style.border = `2px solid var(--mantine-color-${tool.color}-6)`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                        e.currentTarget.style.border = '2px solid transparent';
                      }}
                    >
                      <Stack align="center" gap="md" style={{ flex: 1, justifyContent: 'space-between', padding: '10px 0' }}>
                        <Stack align="center" gap="md">
                          <ThemeIcon size={70} radius="md" color={tool.color} variant="light">
                            <IconComponent size={40} />
                          </ThemeIcon>
                          <Title order={3} size="1.2rem" fw={600} ta="center">
                            {tool.name}
                          </Title>
                        </Stack>

                        <Text
                          size="sm"
                          c="dimmed"
                          ta="center"
                          style={{ lineHeight: 1.4, flex: 1, display: 'flex', alignItems: 'center', padding: '0 10px' }}
                        >
                          {tool.description}
                        </Text>

                        <Text
                          size="xs"
                          c={tool.color}
                          ta="center"
                          fw={600}
                          style={{ textTransform: 'uppercase', letterSpacing: '0.5px', opacity: 0.8 }}
                        >
                          Click to select
                        </Text>
                      </Stack>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>

            <Stack align="center" gap="xs" style={{ marginTop: '20px' }}>
              <Text size="xs" style={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center' }}>
                Presidio Networked Solutions, Inc.
              </Text>
            </Stack>
          </Stack>
        </Center>
      </Container>
    </Box>
  );
}

export default CcUtilsHub;
